const setPatternFromLocalStorage = () => {
	const $dropdownPattern = $('.dropdown--pattern');

	if ($dropdownPattern.length === 0 && localStorage.getItem('patternName') != null) {
		return;
	}

	const $triggerPattern = $dropdownPattern.find('[data-pattern="' + localStorage.getItem('patternName') + '"]').closest('.pattern');

	$triggerPattern.trigger('click');
}

setPatternFromLocalStorage();
